import _ from 'lodash';
import {applySnapshot, types as t,} from 'mobx-state-tree';

export const initialOrderStore = {
    orderId: null,
    positions: [],
};

export const OrderStore = t
    .model({
        orderId: t.maybeNull(t.string),
        positions: t.array(t.model({
            documentId: t.string,
            url: t.string,
            name: t.string,
            quantity: t.number,
            price: t.number,
            aromaDocumentId: t.maybeNull(t.string),
            aromaName: t.maybeNull(t.string),
        })),
    })
    .actions((self) => ({
        clearState: () => {
            applySnapshot(self, initialOrderStore);
        },
        addPosition: (documentId: string, url: string, name: string, price: number, aromaDocumentId?: string | null, aromaName?: string | null) => {
            let pos = self.positions
            pos.push({
                documentId,
                url,
                name,
                quantity: 1,
                price,
                aromaDocumentId: aromaDocumentId ?? null,
                aromaName: aromaName ?? null,
            })
            self.positions = pos;
        },
        removePosition: (documentId: string, aromaDocumentId?: string | null) => {
            let pos = self.positions
            const index = _.findIndex(pos, (item) => item.documentId === documentId && (item.aromaDocumentId ?? '') === (aromaDocumentId ?? ''))
            if (index >= 0) {
                pos.splice(index, 1)
                self.positions = pos;
            }
        },
        plusQuantity: (documentId: string, aromaDocumentId?: string | null) => {
            let pos = self.positions
            const index = _.findIndex(pos, (item) => item.documentId === documentId && (item.aromaDocumentId ?? '') === (aromaDocumentId ?? ''))
            if (index >= 0) {
                pos[index].quantity += 1;
                self.positions = pos;
            }
        },
        minusQuantity: (documentId: string, aromaDocumentId?: string | null) => {
            let pos = self.positions
            const index = _.findIndex(pos, (item) => item.documentId === documentId && (item.aromaDocumentId ?? '') === (aromaDocumentId ?? ''))
            if (index >= 0) {
                if (pos[index].quantity > 1) {
                    pos[index].quantity -= 1;
                } else {
                    pos.splice(index, 1)
                }
                self.positions = pos;
            }
        },
    }));
